var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPinchZoomOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "pinch_zoom_out_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#pinch_zoom_out_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87858B",
  d: "M9.883 15.335a2.006 2.006 0 0 1-1.417-.584l-3.4-3.416.5-.517c.178-.178.386-.297.625-.358.239-.062.475-.059.708.008l1.1.317v-5.45c0-.19.064-.348.192-.475a.645.645 0 0 1 .475-.192c.189 0 .347.064.475.192a.645.645 0 0 1 .192.475V10h.666v-2c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.191c.189 0 .347.064.475.191a.645.645 0 0 1 .192.475v2h.666V8.668c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.192c.189 0 .347.064.475.192a.645.645 0 0 1 .192.475v1.333h.666c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.191c.189 0 .347.064.475.191a.645.645 0 0 1 .192.475v2.667c0 .733-.261 1.361-.784 1.883a2.568 2.568 0 0 1-1.883.784H9.883ZM.666 8V4.668h1v1.633l1.983-1.983.7.7-1.983 1.983h1.633v1H.666Zm4.35-3.65-.7-.7 1.983-1.983H4.666v-1h3.333v3.333H7V2.368L5.016 4.351Z"
}))));
export default SvgPinchZoomOut;